exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-pills.agreements .nav-link{color:#fff!important;margin:0 10px 10px 0}.required-checkbox{width:15px;height:15px}.fa-cog{cursor:pointer}.card>.card-body{padding-top:12px;padding-bottom:12px}.card{cursor:pointer;margin-bottom:10px}.subcategory-container{width:100%}.subcategory-card{cursor:default;background-color:#f5f5f5;margin-left:auto;width:90%}.subcategory-actions{float:right}.btn-icon{margin-left:15px}", ""]);

// exports
